module.exports = __webpack_public_path__ + "static/scale-model-of-center-for-creative-photography-in-tucson-arizona-0e384f340312147cdc9e23ed01be6262.png";